import React, { useEffect, useState } from 'react';
import Pagination from '../../../../../../components/common/pagination';
import { debounce } from 'lodash';
import SmartFilter from '../../../../../../components/common/smartFilter';
import DateFragmentBox from '../../../../../../components/common/DateFragmentBox';
import {
	capitalizeFirstLetter,
	checkDisputeStatus,
	checkDisputeStatusColor,
	downloadCsvFile,
	formatDateHelper,
	formatMetaData,
	formatTypeFunction,
	maskCardNumber,
	trimLongString,
} from '../../../../../../utils/helper/Helper';
import {
	RavenBadge,
	RavenCopyText,
	RavenNumberFormat,
	RavenTable,
	RavenTableRow,
} from '@ravenpay/raven-bank-ui';
import ExportModal from '../../../../../../components/common/exportModal';
import { bankboxAPI } from '../../../../../../redux/bankbox';
import { useDispatch, useSelector } from 'react-redux';
import RootState from '../../../../../../redux/types';
import EmptyScreen from '../../../../../../components/common/emptyScreen';
import DisputeDetailModal from '../../../disputes/DisputeDetailModal';

const Dispute = () => {
	const dispatch = useDispatch();
	const [showExport, setShowExport] = useState<boolean>(false);
	const [modalData, setModalData] = useState<any | null>(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [searchData, setSearchData] = useState([]);

	type showModalProp = {
		create: boolean;
		export: boolean;
		showdetails: boolean;
		view: boolean;
		status: boolean;
	};

	const [refreshTable, setRefreshTable] = useState(false);
	const merchant_email = localStorage?.getItem('merchant-email-user-preview');
	const { all_single_disputes, user_merchant, loading_diputes } = useSelector(
		(state: RootState) => state.bankbox
	);

	useEffect(() => {
		if (Object?.keys(user_merchant)?.length > 0 && merchant_email) {
			getSingleAllDispute();
		}
	}, [currentPage, user_merchant]);

	const getSingleAllDispute = async () => {
		dispatch(
			bankboxAPI.getSingleAllDisputes({
				per_page: 20,
				page: currentPage,
				email: merchant_email,
			})
		);

		// //(data);

		// //(data);
	};

	// const handleFinish = () => {
	// 	setShowModal((prev) => {
	// 		return { ...prev, view: false, status: false };
	// 	});
	// 	setRefreshTable(!refreshTable);
	// };

	const handleFinish = () => {
		setShowModal((prev) => {
			return { ...prev, view: false, status: false };
		});
		setRefreshTable(!refreshTable);
	};

	const csvHeader = [
		{ label: 's/n', key: 'sn' },
		{ label: 'terminal ID', key: 'id' },
		{ label: 'direction', key: 'direction' },
		{ label: 'system_reference', key: 'system_reference' },
		{ label: 'business_email', key: 'business_email' },
		{ label: 'type', key: 'type' },
		{ label: 'amount', key: 'amount' },
		{ label: 'credited_amount', key: 'credited_amount' },
		{ label: 'merchant_settlement', key: 'merchant_settlement' },
		{ label: 'fee', key: 'fee' },
		{ label: 'platform_fee', key: 'platform_fee' },
		{ label: 'balance_before', key: 'balance_before' },
		{ label: 'balance_after', key: 'balance_after' },
		{ label: 'stamp_duty', key: 'stamp_duty' },
		{ label: 'terminal_label', key: 'terminal_label' },
		{ label: 'transaction_reference', key: 'tranx_reference' },
		{ label: 'transaction_details', key: 'transaction_details' },
		{ label: 'provider', key: 'provider' },
		{ label: 'date', key: 'created_at' },
		{ label: 'status', key: 'status' },
	];

	const [singleChild, setSingleChild] = useState<any>({});
	const [showModal, setShowModal] = useState<showModalProp>({
		create: false,
		export: false,
		showdetails: false,
		view: false,
		status: false,
	});

	// Dummy data for all_fees

	const handlesearch = (e: any) => {
		dispatch(
			bankboxAPI.getSingleAllDisputes({
				per_page: 20,
				page: currentPage,
				search: e,
			})
		);
		// setSearchData(all_single_disputes?.data?.transactions);
	};
	// ('search', searchData);
	// (all_single_disputes?.data);

	useEffect(() => {
		if (Array.isArray(all_single_disputes?.data)) {
			setSearchData(all_single_disputes.data);
		}
	}, [all_single_disputes]);

	return (
		<>
			{/* dispute content start */}
			<div
				style={{ marginBottom: '1.5rem' }}
				className="global-search-pagination-filter-box"
			>
				{' '}
				<SmartFilter
					// hideExport
					searchTitle="Search By Type"
					defaultFilterBy="status"
					onSearchChange={debounce((e) => {
						handlesearch(e);
					}, 500)}
					filters={[
						{
							label: 'Status',
							filterBy: 'status',
							options: [
								{
									label: 'Pending',
									value: '0',
								},
								{
									label: 'Review',
									value: '3',
								},
								{
									label: 'Discarded',
									value: '2',
								},
								{
									label: 'Resolved',
									value: '4',
								},
								{ label: 'All Status', value: 'reset' },
							],
						},
					]}
					onExport={() => setShowExport(true)}
					page="sdisputes"
				/>
				<div className="pagination-wrap">
					{' '}
					<Pagination
						className="top-bar__pagination"
						currentPage={currentPage}
						itemsPerPage={all_single_disputes?.pagination?.per_page ?? 0}
						totalItems={all_single_disputes?.pagination?.total ?? 0}
						onPageChange={function (page: number): void {
							setCurrentPage(page);
						}}
					/>
				</div>
			</div>

			{/* dispute content end */}
			<div
				style={{ minHeight: '45rem' }}
				className="transaction__table non-mobile"
			>
				{!all_single_disputes ||
				!all_single_disputes?.data ||
				all_single_disputes?.data?.length < 1 ? (
					<EmptyScreen
						loading={loading_diputes}
						loadingText={
							loading_diputes ? 'Searching...' : 'Loading Dispute...'
						}
						title="No Dispute Found"
						subTitle="You don't have any record yet,your new bankbox transactions will be displayed here."
					/>
				) : (
					<RavenTable
						action={false}
						className="table__main"
						headerList={[
							'REFERENCE',
							'TYPE',
							'NOTE',
							'AMOUNT',
							'DATE LOGGED',
							'STATUS',
						]}
					>
						{all_single_disputes?.data?.map((chi: any, idx: number) => {
							const {
								reference,
								email,
								type,
								Channel,
								note,
								TID,
								BVN,
								status,
								RRN,
								Stan,
								SerialNo,
								Cashier,
								amount,
								Status,
							} = chi || {};
							return (
								<RavenTableRow
									onRowClick={() => {
										setSingleChild(chi);
										setShowModal((prev) => {
											return { ...prev, view: true };
										});
									}}
									loading={loading_diputes}
									// onRowClick={() => handleRowClick(chi)}
									key={idx}
									one={
										<RavenCopyText
											text={
												chi?.transactions?.length > 0
													? chi?.transactions[0]?.reference
													: '---'
											}
											trimNum={30}
											clickable
											stopPropagation
											color="deep-green-light"
											copyIconColor="var(--primary-base-color)"
											copyIconBgColor="var(--primary-accent-color-one)"
											copiedBgColor=" var(--primary-base-color)"
										/>
									}
									two={type}
									three={trimLongString(note, 20) || '---'}
									four={RavenNumberFormat(amount || '----')}
									five={<DateFragmentBox date={chi?.created_at} />}
									six={
										<>
											{/* Render badges based on the Status */}
											<RavenBadge
												type={checkDisputeStatusColor(status)}
												text={trimLongString(
													String(
														checkDisputeStatus(status) === 'rejected'
															? 'Rejected'
															: checkDisputeStatus(status)
													),
													10
												)}
											/>
										</>
									}
								/>
							);
						})}
					</RavenTable>
				)}
			</div>

			{/* Modal */}
			<DisputeDetailModal
				onCancel={() => {
					setShowModal((prev) => {
						return { ...prev, view: false };
					});
				}}
				visible={showModal?.view}
				detail={singleChild}
				onFinish={handleFinish}
				onStatus={() => {
					setShowModal((prev) => {
						return { ...prev, status: true, view: false };
					});
				}}
			/>

			{/* view detail modal end */}
			<ExportModal
				onClose={() => setShowExport(false)}
				visible={showExport}
				page="disputes"
				onFinishExport={(param) => {
					// formatExportData(param);
					window.open(param, '_blank')?.focus();
				}}
			/>
		</>
	);
};

export default Dispute;
